<div class="d-flex align-items-center flex-wrap mb-3">
  <h3 class="mb-0 me-3">Inso docker</h3>
  <div class="form-check me-3">
    <input class="form-check-input" type="checkbox" id="idLive" [checked]="live" (change)="toggleLive()">
    <label class="form-check-label" for="idLive">live</label>
  </div>
  <select class="form-select form-select-sm w-auto me-2" [(ngModel)]="groupBy" (ngModelChange)="filterChanged()">
    <option value="none">no grouping</option>
    <option value="tenant">group by tenant</option>
    <option value="vmPrefix">group by vm prefix</option>
    <option value="tenantVmPrefix">group by tenant and vm prefix</option>
    <option value="image">group by image</option>
  </select>
  <input class="form-control form-control-sm w-auto me-2" type="search" placeholder="filter"
         [(ngModel)]="search" (ngModelChange)="filterChanged()">
  <button type="button" class="btn btn-sm btn-secondary me-2" (click)="reload()">reload</button>
  <button type="button" class="btn btn-sm btn-outline-secondary me-2" (click)="refreshUpstream()"
          [disabled]="upstreamRefreshing"
          title="ask github and the registries right now which versions are the newest ones">
    {{upstreamRefreshing ? 'checking upstream…' : 'check upstream'}}
  </button>
  <button type="button" class="btn btn-sm btn-outline-secondary" (click)="toggleRules()">
    rules ({{rules.length}})
  </button>
  @if (overview) {
    <span class="id-info ms-auto">
      last scan {{overview.lastScan ? (overview.lastScan | date:'yyyy-MM-dd HH:mm:ss') : 'never'}}
      &middot; generated {{overview.generated | date:'HH:mm:ss'}}
      &middot; {{overview.rows.length}} image(s)
    </span>
  }
</div>

<div class="d-flex align-items-center flex-wrap mb-3">
  @for (status of allStatus; track status) {
    <button type="button" [class]="'btn btn-sm me-2 mb-1 id-status-btn ' + statusClass(status)"
            [class.id-off]="!visibleStatus[status]" (click)="toggleStatus(status)">
      {{status.toLowerCase()}} {{countOf(status)}}
    </button>
  }
  <button type="button" class="btn btn-sm me-2 mb-1 id-status-btn st-planned" [class.id-off]="!showPlanned"
          (click)="togglePlanned()"
          title="rows somebody already planned an update for, they are shown whatever their status filter says">
    planned {{plannedCount()}}
  </button>
  <button type="button" class="btn btn-sm me-2 mb-1 id-status-btn id-down-badge" [class.id-off]="!showDown"
          (click)="toggleDown()"
          title="rows whose vm did not report in the last scans, nothing is concluded from their status">
    not reporting {{downCount()}}
  </button>
</div>

<!-- the tenants, switching one off takes it out of the tables and out of the columns of the matrix -->
<div class="d-flex align-items-center flex-wrap mb-3">
  @for (tenant of tenants; track tenant) {
    <button type="button" class="btn btn-sm me-2 mb-1 id-tenant-btn"
            [class.btn-secondary]="!hiddenTenants.has(tenant)"
            [class.btn-outline-secondary]="hiddenTenants.has(tenant)"
            [class.id-off]="hiddenTenants.has(tenant)" (click)="toggleTenant(tenant)">
      {{tenant}} {{tenantCount(tenant)}}
    </button>
  }
</div>

<!-- the patch day, the list that should get smaller and smaller -->
<div class="card mb-3">
  <div class="card-header d-flex align-items-center flex-wrap">
    <strong class="me-3">patch day</strong>
    <select class="form-select form-select-sm w-auto me-2" [ngModel]="selectedPatchDayId"
            (ngModelChange)="selectPatchDay($event)">
      <option [ngValue]="null">none</option>
      @for (patchDay of patchDays; track patchDay.id) {
        <option [ngValue]="patchDay.id">
          {{patchDay.day}} {{patchDay.title}} ({{patchDay.doneCount}}/{{patchDay.doneCount + patchDay.plannedCount}}{{patchDay.closed ? ', closed' : ''}})
        </option>
      }
    </select>
    <button type="button" class="btn btn-sm btn-primary me-2" (click)="newPatchDayForm()">new patch day</button>
    @let current = selectedPatchDay();
    @if (current) {
      <button type="button" class="btn btn-sm btn-outline-secondary me-2" (click)="togglePatchDayClosed(current)">
        {{current.closed ? 'reopen' : 'close'}}
      </button>
      <button type="button" class="btn btn-sm btn-outline-secondary me-2" (click)="copyPatchDayMarkdown(current)"
              title="the items of this patch day as a markdown task list in the clipboard, to paste into a gitlab issue">
        markdown
      </button>
      <button type="button" class="btn btn-sm btn-outline-danger" (click)="deletePatchDay(current)">delete</button>
      <span class="ms-auto">
        <span class="badge id-badge st-planned me-1">{{openItems().length}} remaining</span>
        <span class="badge id-badge st-up_to_date">{{closedItems().length}} done</span>
      </span>
    }
  </div>

  @if (newPatchDay) {
    <div class="card-body border-bottom">
      <div class="row g-2 align-items-end">
        <div class="col-auto">
          <label class="form-label mb-0">day</label>
          <input class="form-control form-control-sm" type="date" [(ngModel)]="newPatchDay.day">
        </div>
        <div class="col">
          <label class="form-label mb-0">title</label>
          <input class="form-control form-control-sm" type="text" [(ngModel)]="newPatchDay.title" placeholder="september patch day">
        </div>
        <div class="col-auto">
          <button type="button" class="btn btn-sm btn-primary me-1" (click)="savePatchDay()">save</button>
          <button type="button" class="btn btn-sm btn-secondary" (click)="cancelPatchDay()">cancel</button>
        </div>
      </div>
    </div>
  }

  <div class="card-body">
    @if (selectedPatchDayId === null) {
      <div class="text-muted">no patch day selected, pick one or create one to plan version updates</div>
    } @else {
      @if (selectedItems.size) {
        <div class="d-flex align-items-center flex-wrap mb-2">
          <span class="me-2">{{selectedItems.size}} ticked</span>
          <select class="form-select form-select-sm w-auto me-2" [ngModel]="moveTargetId" (ngModelChange)="moveItems($event)">
            <option [ngValue]="null">move to …</option>
            @for (patchDay of otherPatchDays(); track patchDay.id) {
              <option [ngValue]="patchDay.id">{{patchDay.day}} {{patchDay.title}}{{patchDay.closed ? ' (closed)' : ''}}</option>
            }
          </select>
          <button type="button" class="btn btn-sm btn-outline-secondary" (click)="selectedItems.clear()">untick</button>
        </div>
      }
      <table class="table table-sm id-table mb-0">
        <thead>
        <tr>
          <th class="id-tick">
            <input class="form-check-input" type="checkbox" title="tick everything on this patch day"
                   [checked]="allItemsSelected()" (change)="toggleAllItems()">
          </th>
          <th>image</th>
          <th>tenant</th>
          <th>vm</th>
          <th>from</th>
          <th>to</th>
          <th>still running</th>
          <th>comment</th>
          <th></th>
        </tr>
        </thead>
        <tbody>
        @for (item of openItems(); track item.id) {
          <tr class="st-planned">
            <td class="id-tick">
              <input class="form-check-input" type="checkbox" [checked]="isItemSelected(item)" (change)="toggleItem(item)">
            </td>
            <td>{{item.image}}</td>
            <td>{{item.tenant ?? 'all'}}</td>
            <td>{{item.vm ?? (item.vms.length ? item.vms.join(', ') : 'all')}}</td>
            <td>{{item.fromVersion ?? (item.currentVersions.join(', ') || '?')}}</td>
            <td>
              <strong>{{item.toVersion ?? '?'}}</strong>
              @let newest = itemNewest(item);
              @if (newest) {
                <button type="button" class="btn btn-sm btn-link p-0 ms-1" (click)="bumpItem(item, newest)"
                        title="a newer version was released since this was planned, take it over as the target">→ {{newest}}</button>
              }
            </td>
            <td>
              @let left = itemLeft(item);
              @if (left.length) {
                <span class="badge id-badge st-outdated">{{left.join(', ')}}</span>
              } @else if (item.downVms.length) {
                <span class="badge id-badge id-down-badge">nothing, but waiting for a scan</span>
              } @else {
                <span class="badge id-badge st-up_to_date">nothing, scan will tick it off</span>
              }
              @if (item.downVms.length) {
                <span class="id-info ms-1" title="these vms do not answer, their versions are the last ones we saw">
                  {{item.downVms.join(', ')}} down
                </span>
              }
            </td>
            <td>{{item.comment}}</td>
            <td class="text-nowrap">
              <button type="button" class="btn btn-sm btn-success me-1" (click)="setItemStatus(item, 'DONE')">done</button>
              <button type="button" class="btn btn-sm btn-outline-secondary me-1" (click)="setItemStatus(item, 'SKIPPED')">skip</button>
              <button type="button" class="btn btn-sm btn-outline-danger" (click)="deleteItem(item)">x</button>
            </td>
          </tr>
        } @empty {
          <tr><td colspan="9" class="text-muted">nothing left to do for this patch day</td></tr>
        }
        @for (item of closedItems(); track item.id) {
          <tr [class]="item.status === 'DONE' ? 'st-up_to_date' : 'st-ignored'">
            <td class="id-tick">
              <input class="form-check-input" type="checkbox" [checked]="isItemSelected(item)" (change)="toggleItem(item)">
            </td>
            <td>{{item.image}}</td>
            <td>{{item.tenant ?? 'all'}}</td>
            <td>{{item.vm ?? (item.vms.length ? item.vms.join(', ') : 'all')}}</td>
            <td>{{item.fromVersion}}</td>
            <td><strong>{{item.toVersion}}</strong></td>
            <td>
              {{item.status.toLowerCase()}}
              @if (item.doneAt) { {{item.doneAt | date:'yyyy-MM-dd HH:mm'}} }
            </td>
            <td>{{item.comment}}</td>
            <td class="text-nowrap">
              <button type="button" class="btn btn-sm btn-outline-secondary me-1" (click)="setItemStatus(item, 'PLANNED')">reopen</button>
              <button type="button" class="btn btn-sm btn-outline-danger" (click)="deleteItem(item)">x</button>
            </td>
          </tr>
        }
        </tbody>
      </table>
    }
  </div>
</div>

<!-- the rules, this is where a fresh cve turns old versions evil without editing a script -->
@if (showRules) {
  <div class="card mb-3">
    <div class="card-header d-flex align-items-center">
      <strong class="me-3">rules</strong>
      <button type="button" class="btn btn-sm btn-primary" (click)="newRuleForm()">new rule</button>
      <button type="button" class="btn btn-sm btn-outline-secondary ms-auto" (click)="copyRulesMarkdown()"
              title="the rules as a markdown table in the clipboard">markdown</button>
    </div>
    @if (newRule) {
      <div class="card-body border-bottom">
        <div class="row g-2 align-items-end">
          <div class="col">
            <label class="form-label mb-0">image</label>
            <input class="form-control form-control-sm" type="text" [(ngModel)]="newRule.image">
          </div>
          <div class="col-auto">
            <label class="form-label mb-0">type</label>
            <select class="form-select form-select-sm" [(ngModel)]="newRule.type">
              @for (type of ruleTypes; track type) {
                <option [ngValue]="type">{{type.toLowerCase()}}</option>
              }
            </select>
          </div>
          <div class="col-auto">
            <label class="form-label mb-0">version</label>
            <input class="form-control form-control-sm" type="text" [(ngModel)]="newRule.value"
                   [placeholder]="rulePlaceholder(newRule.type)">
          </div>
          <div class="col">
            <label class="form-label mb-0">comment</label>
            <input class="form-control form-control-sm" type="text" [(ngModel)]="newRule.comment" placeholder="cve-2026-...">
          </div>
          <div class="col-auto">
            <button type="button" class="btn btn-sm btn-primary me-1" (click)="saveRule()">save</button>
            <button type="button" class="btn btn-sm btn-secondary" (click)="cancelRule()">cancel</button>
          </div>
        </div>
      </div>
    }
    <div class="card-body">
      <table class="table table-sm id-table mb-0">
        <thead>
        <tr>
          <th>image</th>
          <th>type</th>
          <th>version</th>
          <th>comment</th>
          <th>created</th>
          <th></th>
        </tr>
        </thead>
        <tbody>
        @for (rule of rules; track rule.id) {
          <tr [class.faded]="!rule.active">
            <td>{{rule.image}}</td>
            <td><span [class]="'badge id-badge ' + (rule.type === 'CRITICAL_BELOW' || rule.type === 'ABANDONED' ? 'st-critical' : rule.type === 'IGNORE' ? 'st-ignored' : 'st-unknown')">{{rule.type.toLowerCase()}}</span></td>
            <td>{{rule.value}}</td>
            <td>{{rule.comment}}</td>
            <td>{{rule.created | date:'yyyy-MM-dd HH:mm'}} {{rule.createdBy}}</td>
            <td class="text-nowrap">
              <button type="button" class="btn btn-sm btn-outline-secondary me-1" (click)="toggleRuleActive(rule)">
                {{rule.active ? 'deactivate' : 'activate'}}
              </button>
              <button type="button" class="btn btn-sm btn-outline-danger" (click)="deleteRule(rule)">x</button>
            </td>
          </tr>
        } @empty {
          <tr><td colspan="6" class="text-muted">no rules yet</td></tr>
        }
        </tbody>
      </table>
    </div>
  </div>
}

<!-- planning one update, the defaults come from what is running and what is newest -->
@if (plan) {
  <div class="modal d-block" tabindex="-1" (click)="cancelPlan()">
    <div class="modal-dialog modal-lg modal-dialog-centered" (click)="$event.stopPropagation()"
         (keyup.enter)="savePlan()">
      <div class="modal-content id-plan">
        <div class="modal-header"><strong>plan a version update</strong></div>
        <div class="modal-body">
          <div class="row g-2 align-items-end">
            <div class="col">
              <label class="form-label mb-0">image</label>
              <input class="form-control form-control-sm" type="text" [(ngModel)]="plan.image">
            </div>
            <div class="col-auto">
              <label class="form-label mb-0">from</label>
              <input class="form-control form-control-sm" type="text" [(ngModel)]="plan.fromVersion">
            </div>
            <div class="col-auto">
              <label class="form-label mb-0">to</label>
              <input class="form-control form-control-sm" type="text" [(ngModel)]="plan.toVersion">
            </div>
            <div class="col">
              <label class="form-label mb-0">comment</label>
              <input class="form-control form-control-sm" type="text" [(ngModel)]="plan.comment">
            </div>
            <div class="col-auto">
              <div class="form-check">
                <input class="form-check-input" type="checkbox" id="idAllVms" [(ngModel)]="plan.allVms">
                <label class="form-check-label" for="idAllVms">all vms of {{plan.tenant}}</label>
              </div>
              <div class="form-check">
                <input class="form-check-input" type="checkbox" id="idAllTenants" [(ngModel)]="plan.allTenants">
                <label class="form-check-label" for="idAllTenants">all tenants</label>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-sm btn-primary me-1" (click)="savePlan()">plan it</button>
          <button type="button" class="btn btn-sm btn-secondary" (click)="cancelPlan()">cancel</button>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-backdrop show"></div>
}

@for (group of groups; track group.name) {
  <div class="card mb-3">
    <div class="card-header d-flex align-items-center">
      <strong>{{group.name}}</strong>
      <span class="ms-3">
        @if (group.criticalCount) { <span class="badge id-badge st-critical me-1">{{group.criticalCount}} critical</span> }
        @if (group.outdatedCount) { <span class="badge id-badge st-outdated me-1">{{group.outdatedCount}} outdated</span> }
        <span class="id-info">{{group.rows.length}} image(s)</span>
      </span>
      <button type="button" class="btn btn-sm btn-outline-secondary ms-auto" (click)="copyGroupMarkdown(group)"
              title="the rows of this card as a markdown table in the clipboard">markdown</button>
    </div>
    <div class="card-body">
      <table class="table table-sm id-table mb-0">
        <thead>
        <tr>
          <th>image</th>
          <th>version</th>
          <th>newest</th>
          <th>status</th>
          <th>tenant</th>
          <th>vm</th>
          <th>containers</th>
          <th>compose dir</th>
          <th>seen</th>
          <th></th>
        </tr>
        </thead>
        <tbody>
        @for (row of group.rows; track row.tenant + row.vm + row.image + row.tag) {
          <tr [class]="rowClass(row)">
            <td>{{row.image}}</td>
            <td><strong>{{row.tag}}</strong></td>
            <td>
              {{row.latestVersion ?? '?'}}
              <span class="id-info">{{row.source.toLowerCase()}}</span>
            </td>
            <td>
              <span [class]="'badge id-badge ' + statusClass(row.status)">{{row.status.toLowerCase()}}</span>
              @if (row.planned) {
                <span class="badge id-badge st-planned ms-1" title="an update of this one is planned for that patch day">{{plannedLabel(row)}}</span>
              }
              @if (row.criticalBelow) {
                <span class="id-info ms-1">&lt; {{row.criticalBelow}}</span>
              }
              @if (row.abandoned) {
                <span class="id-info ms-1" title="nobody builds this image any more, it needs to be replaced">abandoned</span>
              }
            </td>
            <td>{{row.tenant}}</td>
            <td>{{row.vm}}</td>
            <td class="break">{{row.containers.join(', ')}}@if (row.containerCount > row.containers.length) { &hellip; ({{row.containerCount}}) }</td>
            <td class="break id-info">{{row.composeDirs.join(', ')}}</td>
            <td class="id-info">
              {{row.lastSeen | date:'yyyy-MM-dd HH:mm'}}
              @if (!row.reporting) {
                <span class="id-down-badge badge id-badge ms-1" title="the vm does not answer, so this is the last thing we know">down</span>
              }
            </td>
            <td class="text-nowrap">
              <button type="button" class="btn btn-sm btn-primary me-1" (click)="openPlan(row)">plan</button>
              <button type="button" class="btn btn-sm btn-outline-primary me-1" (click)="pull(row)"
                      title="docker pull of this image on this vm, the report lands in the stracli commands">pull</button>
              <button type="button" class="btn btn-sm btn-outline-danger me-1" (click)="declareEvil(row)"
                      title="a cve just came out, everything below the newest version is critical">evil</button>
              <button type="button" class="btn btn-sm btn-outline-danger me-1" (click)="abandonImage(row)"
                      title="nobody builds this image any more, every tag of it is critical until it is replaced">dead</button>
              <button type="button" class="btn btn-sm btn-outline-secondary" (click)="ignoreImage(row)">ignore</button>
            </td>
          </tr>
        }
        </tbody>
      </table>
    </div>
  </div>
} @empty {
  <div class="text-muted">nothing to show, either no scan arrived yet or every status is filtered away</div>
}

<!-- the same data the other way round: one row per image, one column per tenant, a cell is what runs there -->
<div class="card mb-3">
  <div class="card-header d-flex align-items-center">
    <strong>versions per tenant</strong>
    <span class="id-info ms-3">
      every image against every tenant, the filters above drop whole tenants and images but never a single version
      &middot; click a version to plan its update
    </span>
    <button type="button" class="btn btn-sm btn-outline-secondary ms-auto text-nowrap" (click)="copyMatrixMarkdown()"
            title="this matrix as a markdown table in the clipboard">markdown</button>
  </div>
  <div class="card-body table-responsive">
    <table class="table table-sm id-table id-matrix mb-0">
      <thead>
      <tr>
        <th>image</th>
        @for (tenant of matrixTenants; track tenant) {
          <th>{{tenant}}</th>
        }
        <th>newest</th>
      </tr>
      </thead>
      <tbody>
      @for (row of matrix; track row.image) {
        <tr>
          <td class="id-matrix-image">{{row.image}}</td>
          @for (cell of row.cells; track cell.tenant) {
            <td>
              @for (version of cell.versions; track version.tag) {
                <span [class]="'badge id-badge id-matrix-chip me-1 ' + version.cls" [title]="version.title"
                      (click)="planFromMatrix(version)">
                  {{version.tag}}@if (version.vms.length > 1) { <span class="id-matrix-count">&times;{{version.vms.length}}</span> }
                </span>
              } @empty {
                <span class="id-matrix-empty">&ndash;</span>
              }
            </td>
          }
          <td class="id-info">{{row.newestVersion ?? '?'}}</td>
        </tr>
      } @empty {
        <tr><td [attr.colspan]="matrixTenants.length + 2" class="text-muted">nothing to show, either no scan arrived yet or the filters above hid everything</td></tr>
      }
      </tbody>
    </table>
  </div>
</div>
